import styled from 'styled-components';

export const ContentWrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: column;
    gap: 0.5em;
    border-radius: 30px;
    overflow: hidden;
    
    background: #e9f3f2;
    z-index: 0;
    -webkit-box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.31);
    box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.31);
`;

export const TitleListWrapper = styled.div`
    position: relative;
    width: 100%;
    min-height: 4.5em;
    color: #838484;
    padding: 0 0.5em;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    background: #fdfdfd;
    z-index: 0;
    overflow: hidden;
    border-radius: 30px;
    -webkit-box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.31);
    box-shadow: -2px 8px 2px -6px rgba(41,127,118,0.31);
    &::before {
        position: absolute;
        content: '';
        width: 3.5em;
        height: 3.5em;
        background: rgba(76,148,141, 0.7);
        right: 1em;
        bottom: -1.5em;
        border-radius: 50%;
        z-index: -1;
    }
    &::after {
        position: absolute;
        content: '';
        width: 2.5em;
        height: 2.5em;
        background: rgba(76,148,141, 0.7);
        right: 4em;
        top: -1em;
        border-radius: 50%;
        z-index: -1;
    }
`;

export const AzmanotListWrapper = styled.div`
    width: 100%;
    height: 100%;
    max-width: 100%;
    background: #fdfdfd;
    border-radius: 20px;
    overflow-y: scroll;
    padding: 0.5em 0.5em;
    &::-webkit-scrollbar {
        width: 0;
    }
`;

export const ContainerImg = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;
